import { SearchItem } from '@/components';
import { useDebounced } from '@/hooks';
import { Role } from '@/modules/Users/domain/role';
import { useGetUsersBaseInfo } from '@/modules/Users/queries';
import { RoleEntity } from '@/modules/Users/types/role';
import { useState } from 'react';
import { AssociateUserForm } from '../AssociateUserForm/AssociateUserForm';

type AssociateUserTabProps = {
  onClose: () => void;
  onSubmit: (items: SearchItem<{ role?: number }>[]) => void;
  isSubmitting: boolean;
  roles?: Role[];
  businessAreaId?: number;
  roleEntity?: RoleEntity;
};

export const AssociateUserTab = ({
  onClose,
  onSubmit,
  isSubmitting,
  businessAreaId,
  roles,
  roleEntity,
}: AssociateUserTabProps) => {
  const [searchTerm, setSearchTerm] = useState<string>('');
  const debouncedSearchTerm = useDebounced(searchTerm, 500) as string;
  const { data: users } = useGetUsersBaseInfo(
    {
      searchTerm: debouncedSearchTerm,
      businessAreaId,
    },
    {
      disabled: !debouncedSearchTerm,
    },
  );

  return (
    <AssociateUserForm
      onClose={onClose}
      onSubmit={onSubmit}
      onUserSearch={setSearchTerm}
      userSearch={searchTerm}
      users={users ?? []}
      roles={roles}
      isSubmitting={isSubmitting}
      roleEntity={roleEntity}
    />
  );
};
